export default {
  PROJECT_TYPES: {
    MULTITOWER_TYPE: 'Multitower',
    SINGLETOWER_TYPE: 'Single Tower',
    NEIGHBOURHOOD_TYPE: 'Neighbourhood',
  },
}
